/**
 * Organization Service
 *
 * Service for managing organization data.
 * Uses ApiResponse<T> pattern - response.data is already T.
 */

import { apiClient } from "@/services/shared/infrastructure";
import { makeService } from "@/services/shared/infrastructure/service-wrapper";
import { getEffectiveOrgId } from "@/services/shared/infrastructure/tenant-state";
import type { Organization } from "./identity.view-models";

const rawOrganizationService = {
  async getOrganization(): Promise<Organization> {
    const orgId = getEffectiveOrgId();
    if (!orgId) {
      throw new Error("Organization ID is required");
    }

    const response = await apiClient.get<Organization>(
      `/orgs/${orgId}/identity/org`,
    );
    return response.data;
  },

  async updateOrganization(data: {
    name?: string;
    slug?: string;
    settings?: Record<string, unknown>;
  }): Promise<Organization> {
    const orgId = getEffectiveOrgId();
    if (!orgId) {
      throw new Error("Organization ID is required");
    }

    const response = await apiClient.patch<Organization>(
      `/orgs/${orgId}/identity/org`,
      data,
    );
    return response.data;
  },
};

export const organizationService = makeService(
  rawOrganizationService,
  "organization",
);
